/// <reference types="./getChangelogEventsTotalCount.d.ts" />
import { ok } from '@dossierhq/core';
import {} from '@dossierhq/database-adapter';
import { queryOne } from '../QueryFunctions.js';
import { generateGetChangelogTotalCountQuery, } from './ChangelogQueryGenerator.js';
export async function eventGetChangelogEventsTotalCount(database, context, query, entity) {
    const sqlQueryResult = generateGetChangelogTotalCountQuery(query, entity);
    if (sqlQueryResult.isError())
        return sqlQueryResult;
    const totalResult = await queryOne(database, context, sqlQueryResult.value);
    if (totalResult.isError())
        return totalResult;
    return ok(totalResult.value.count);
}
//# sourceMappingURL=getChangelogEventsTotalCount.js.map